import { SidebarType as o } from "@scalar-org/entities/project";
function u(n, e) {
  const f = n.items, i = [];
  function l(t) {
    f[t]?.type === o.Page && i.push(t), f[t]?.children && f[t]?.children?.forEach((d) => {
      l(d);
    });
  }
  n.children.forEach((t) => l(t));
  const r = i.indexOf(e);
  return r === -1 ? { prevUid: null, nextUid: null } : {
    prevUid: r > 0 ? i[r - 1] : null,
    nextUid: r < i.length - 1 ? i[r + 1] : null
  };
}
function p(n, e) {
  return !e || !n ? null : u(n, e.uid).prevUid;
}
function U(n, e) {
  return !e || !n ? null : u(n, e.uid).nextUid;
}
export {
  U as findNextPage,
  p as findPreviousPage,
  u as getAdjacentUids
};
